import { useQuery } from '@tanstack/react-query'

import { ClientLocationSpeciesService } from '@services/client_location_species.service'
import { APILocationSpeciesClientDtoResponse } from '../types/api'
import { defaultQueryOptions } from './common'

export const useClientLocationSpecies = (
  locationName: string,
  includeBreeds = false,
  options?: { enabled?: boolean }
) => {
  const { enabled = true } = options || {}
  return useQuery<APILocationSpeciesClientDtoResponse>({
    queryKey: ['clientLocationSpecies', locationName, includeBreeds],
    queryFn: () => ClientLocationSpeciesService.getSpecies(locationName, includeBreeds),
    ...defaultQueryOptions,
    enabled,
  })
}
